import * as jwtDecode from 'jwt-decode';
import { IDecodedToken } from '../../interface/auth/decoded-token.interface';

export function decodeToken(accessToken: string): IDecodedToken {
  return jwtDecode(accessToken);
}
